module.exports = __webpack_public_path__ + "static/media/galerija_2023 (4).cc31210e.JPG";